import { TipLinkEmbed } from "./embed.js";
import { TipLinkWalletAdapter } from "./index.js";
export const getTipLinkUrl = (buildEnv) => {
    switch (buildEnv) {
        case "production":
            return "https://tiplink.io";
        case "staging":
            return "https://staging.tiplink.io";
        case "development":
            return "https://dev.tiplink.io";
        case "adapter":
            return "https://adapter.tiplink.io";
        case "local":
            return "http://localhost:3000";
    }
};
export function getCloseButtonUrl(buildEnv) {
    const logoUrl = new URL("adapter-popup-close-icon.svg", getTipLinkUrl(buildEnv));
    return logoUrl.toString();
}
export const TIPLINK_ADAPTER_KEY = "TipLinkAdapter";
export const TIPLINK_EMBED_KEY = "TipLinkEmbed";
export var TipLinkInstanceKey;
(function (TipLinkInstanceKey) {
    TipLinkInstanceKey["ADAPTER"] = "TipLinkAdapter";
    TipLinkInstanceKey["EMBED"] = "TipLinkEmbed";
})(TipLinkInstanceKey || (TipLinkInstanceKey = {}));
const TIPLINK_INSTANCES = {
    [TIPLINK_ADAPTER_KEY]: undefined,
    [TIPLINK_EMBED_KEY]: undefined,
};
export function removePreviousWindowRef(key) {
    if (!(key in TIPLINK_INSTANCES))
        return;
    TIPLINK_INSTANCES[key] = undefined;
}
export function checkAndRemovePreviousTipLinkInstance(key) {
    try {
        // disconnect previous instance (adapter or embed class)
        if (key === TipLinkInstanceKey.ADAPTER &&
            TIPLINK_INSTANCES[key] instanceof TipLinkWalletAdapter) {
            TIPLINK_INSTANCES[key].disconnect();
        }
        else if (key === TipLinkInstanceKey.EMBED &&
            TIPLINK_INSTANCES[key] instanceof TipLinkEmbed) {
            TIPLINK_INSTANCES[key].clearElements();
        }
        // remove reference of previous instance
    }
    catch (err) {
        console.error(`Error removing previous ${key} instance: `, err);
    }
    finally {
        // detach ref even if error occurs
        removePreviousWindowRef(key);
    }
}
export function checkAndAttachTipLinkInstance(tipLinkInstance) {
    // determine key from instance passed
    const key = tipLinkInstance instanceof TipLinkWalletAdapter
        ? TIPLINK_ADAPTER_KEY
        : tipLinkInstance instanceof TipLinkEmbed
            ? TIPLINK_EMBED_KEY
            : "";
    if (!key)
        return;
    if (key in TIPLINK_INSTANCES && TIPLINK_INSTANCES[key]) {
        checkAndRemovePreviousTipLinkInstance(key);
    }
    TIPLINK_INSTANCES[key] = tipLinkInstance;
}
//# sourceMappingURL=utils.js.map